export default __webpack_public_path__ + "static/media/CMFT WEB.ae49806e.png";